// send message to app webview that animation has started
export const webviewAnimStart = () => {
  // ios
  try {
    window.webkit?.messageHandlers?.animationStarted &&
      window.webkit.messageHandlers.animationStarted.postMessage(true);
  } catch (e) {
    window.evite && window.evite.error('An error occurred in fabricCreateIsPremium(ios): %O', e);
    window.Raven && window.Raven.captureException(e);
  }

  // android
  try {
    if (window.webview?.animationStarted) window.webview.animationStarted(true);
  } catch (e) {
    window.evite &&
      window.evite.error('An error occurred in fabricCreateIsPremium(android): %O', e);
    window.Raven && window.Raven.captureException(e);
  }
};

// send message to app webview that animation has finished
export const webviewAnimFinish = () => {
  // ios
  try {
    window.webkit?.messageHandlers?.animationFinished &&
      window.webkit.messageHandlers.animationFinished.postMessage(true);
  } catch (e) {
    window.evite && window.evite.error('An error occurred in fabricCreateIsPremium(ios): %O', e);
    window.Raven && window.Raven.captureException(e);
  }

  // android
  try {
    if (window.webview?.animationFinished) window.webview.animationFinished(true);
  } catch (e) {
    window.evite &&
      window.evite.error('An error occurred in fabricCreateIsPremium(android): %O', e);
    window.Raven && window.Raven.captureException(e);
  }
};

// send message to app webview that animation has been replayed
export const webviewAnimReplay = () => {
  // ios
  try {
    window.webkit?.messageHandlers?.animationReplay &&
      window.webkit.messageHandlers.animationReplay.postMessage(true);
  } catch (e) {
    window.evite && window.evite.error('An error occurred in fabricCreateIsPremium(ios): %O', e);
    window.Raven && window.Raven.captureException(e);
  }

  // android
  try {
    if (window.webview?.animationReplay) window.webview.animationReplay(true);
  } catch (e) {
    window.evite &&
      window.evite.error('An error occurred in fabricCreateIsPremium(android): %O', e);
    window.Raven && window.Raven.captureException(e);
  }
};
